
<script>

    import scenes from "@/config/scenes";

    export default {

        name: "demo",

        methods: {

            goScenarioOne () {
                this.$router.push(`/scene/${scenes.sc1.id}/project/${scenes.sc1.project}/ov/work`);
            },

            goScenarioTwo () {
                this.$router.push(`/scene/${scenes.sc2.id}/project/${scenes.sc2.project}/ov/coord`);
            },

            goScenarioThree () {
                this.$router.push(`/scene/${scenes.sc3.id}/project/${scenes.sc3.project}/ov/work`);
            },
        },

    }

</script>

<template>
    <div class="ot-demo">
        <div class="demo" @click="goScenarioOne">
            Supplier uploading new container revisions
        </div>
        <div class="demo" @click="goScenarioTwo">
            Co-ordinator looking at co-ordination report
        </div>
        <div class="demo" @click="goScenarioThree">
            User searching for and viewing a component
        </div>
    </div>
</template>

<style scoped lang="less">

    @import (reference) "../../theme/minimum.less";

    .ot-demo {
        display: grid;
        grid-template-columns: 240px 240px 240px;
        grid-column-gap: 1rem;
        grid-template-rows: auto;
        margin: 50px auto;
        max-width: 1000px;
        .demo {
            text-align: center;
            padding: 30px;
            .shadow-z-1();
            cursor: pointer;
            transition: background-color 0.35s ease;
            border-radius: 4px;
            &:hover {
                background-color: @hover-color;
            }
        }
    }
</style>